import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
// import { IdHelper } from 'common-tools/IdHelper'
import { Col, Row } from 'reactstrap'
import { CircleButton } from './CircleButton'
import { FieldArray } from 'redux-form'
import styles from './CollectionBox.less'

class CollectionBoxClass extends React.Component {
  static propTypes = {
    fields: pt.array.isRequired,
    children: pt.func.isRequired,
    name: pt.string,
    keyFieldName: pt.string,
    manualKeyFieldValue: pt.bool,
    onAdd: pt.func,
    hideAdd: pt.bool,
    hideDelete: pt.bool,
    showDivider: pt.bool,
    deleteOverride: pt.func
  }

  newFieldId = 0

  static defaultProps = {
    keyFieldName: 'Id',
    hideAdd: false,
    hideDelete: false,
    showDivider: false,
    manualKeyFieldValue: false
  }

  onAddClick () {
    const { fields, onAdd, keyFieldName, manualKeyFieldValue } = this.props
    if (_.isFunction(onAdd)) {
      let newMember = {}
      if (!manualKeyFieldValue) {
        newMember[keyFieldName] = --this.newFieldId
      }
      newMember = onAdd(newMember)
      fields.push(newMember)
    } else {
      let newMember = {}
      if (!manualKeyFieldValue) {
        newMember[keyFieldName] = --this.newFieldId
      }
      fields.push(newMember)
    }
  }

  onDeleteClick (index) {
    const { fields, keyFieldName, deleteOverride } = this.props
    if (_.isFunction(deleteOverride)) {
      const memberData = fields.get(index)
      const memberDataKey = memberData[keyFieldName]
      deleteOverride(memberDataKey, this.props, index)
    }
    fields.remove(index)
  }

  render () {
    const { keyFieldName, fields, children, name, hideAdd, hideDelete, showDivider, meta, hide = false, show = true } = this.props

    if (hide === true || show === false) {
      return null
    }

    let rows = []

    let errorMessage = meta.error

    const lastIndex = (fields.length || 0) - 1
    // get a row for each existing collection member
    fields.forEach((member, index) => {
      const memberData = fields.get(index)
      const memberDataKey = memberData[keyFieldName]
      const memberFields = children(member, index, memberDataKey, memberData)

      rows.push(
        <Row key={memberDataKey}>
          {memberFields}
          {hideDelete
            ? null
            : <Col sm={12} md={2} lg={2} xl={2}>
              <CircleButton icon='times' size='sm' color='danger' onClick={this.onDeleteClick.bind(this, index)} />
            </Col>
          }
        </Row>
      )
      if (showDivider === true & index !== lastIndex) {
        if (memberFields.skipDivider !== true) {
          rows.push(<hr key={`${member[keyFieldName]}_Divider`} />)
        }
      }
    })

    if (!hideAdd) {
      rows.push(
        <Row key={`${name}Add`}>
          <Col sm={12} md={2} lg={2} xl={2}>
            <CircleButton size='sm' icon='plus' color='success' onClick={this.onAddClick.bind(this)} />
          </Col>
        </Row>
      )
    }

    if (errorMessage) {
      rows.push(
        <Row key={`${name}Error`}>
          <Col sm={12} md={12} lg={12} xl={12}>
            <div className={styles.errorMessage}>
              {errorMessage}
            </div>
          </Col>
        </Row>
      )
    }

    return rows
  }
}

export const CollectionBox = (props) => { return <FieldArray name={props.name} {...props} component={CollectionBoxClass} /> } // eslint-disable-line
export default CollectionBox
